var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{attrs:{"id":"side-panel-tabs"}},[_c('ul',{staticClass:"tabs-rec"},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.id,class:{ active: tab.isActive },on:{"click":function($event){return _vm.tabSelect(tab)}}},[_c('span',{class:tab.icon}),_vm._v(" "+_vm._s(tab.title))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }